import gql from 'graphql-tag';

export const CONTRIBUTOR_PAGE = gql`
	query document($id: String!) {
		document: findContributorById(id: $id) {
			_id
			name
			channels {
				_id
				name
				profileImage
				coverImage
				isCurrentUserSubscribed
				type
				owner {
					_id
					name
				}
			}
		}
	}`;
